/* ============================================================
   6. A FRAME TAGGED no-recommend IS NEVER RECOMMENDED

   THE ASK
   The Relic — both colourways — should never be recommended to anybody. It
   stays on sale and stays in the collection: someone who wants it can find it
   and buy it. It simply must not be put in front of people as a suggestion.

   WHY THE EXISTING TAG WAS NOT ENOUGH
   Both Relics already carried `no-top-pick`, and that tag does less than its
   name suggests. In the scoring loop in the page body:

       if (best.length < 2 && !c.noTop && !seen[c.model]) best.push(c);
       else queue.push(c);

   A no-top-pick frame fails the `!c.noTop` test and falls into `queue` — and
   `queue` is exactly what fills tier 2 ("also worth a look") and tier 3 ("the
   rest that work"). So the tag kept it out of "Suits you most" and then
   recommended it twice anyway. With suits-diamond, suits-heart and
   suits-square on it, that is three of the face shapes.

   WHY THIS IS DONE FROM THE THEME AND NOT FIXED AT SOURCE
   That loop lives in the page body in Shopify admin, which has no preview, no
   diff and no history, and whose editor strips the whole scan engine if the
   page is ever opened and saved (see the note in the project docs). Touching
   it is the riskiest change available. Removing the rendered cards afterwards
   is the cheap, reversible half — and it holds no matter how the scoring
   changes later, because it works on the output rather than the maths.

   HOW
   The tier lists are read after they render, any card pointing at a handle
   tagged `no-recommend` is removed, and a tier left with nothing in it is
   hidden rather than shown as an empty heading. The handle list comes from
   /products.json?limit=250 — the same URL the page itself uses, so it is a
   cache hit rather than a second download.

   It is tag-driven on purpose. Tag any future frame `no-recommend` and it
   disappears from the recommendations with no code change; untag it and it
   comes back. Nothing here names The Relic.

   FAILS OPEN, DELIBERATELY. If the fetch fails the recommendations are left
   exactly as the engine built them. A frame shown when it should not have
   been is a smaller problem than an empty result panel.
   ============================================================ */
(function(){
  'use strict';

  var LISTS = ['bt-best', 'bt-also', 'bt-rest'];
  if(!document.getElementById('bt-best')) return;

  var TAG = 'no-recommend';
  var blocked = null;      /* handle -> 1, once loaded */
  var loading = null;

  function load(){
    if(blocked) return Promise.resolve(blocked);
    if(loading) return loading;
    loading = fetch('/products.json?limit=250', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : { products: [] }; })
      .then(function(d){
        var map = {};
        var list = (d && d.products) || [];
        for(var i = 0; i < list.length; i++){
          var tags = list[i].tags || [];
          for(var j = 0; j < tags.length; j++){
            if(String(tags[j]).toLowerCase().trim() === TAG){ map[list[i].handle] = 1; break; }
          }
        }
        blocked = map;
        return blocked;
      })
      .catch(function(){ blocked = {}; return blocked; });
    return loading;
  }

  function handleOf(a){
    var href = a.getAttribute('href') || '';
    var bit = href.split('?')[0].split('#')[0].split('/products/')[1];
    return bit ? bit.replace(/\/$/, '') : '';
  }

  /* Remove the whole card, not just the link. Walking up to the direct child
     of the list is how that is done without knowing the card's class — the
     markup is built in the page body and is not ours to depend on. */
  function cardIn(box, a){
    var el = a;
    while(el && el.parentNode && el.parentNode !== box) el = el.parentNode;
    return (el && el.parentNode === box) ? el : null;
  }

  function strip(map){
    if(!map) return;
    var removed = 0;

    for(var i = 0; i < LISTS.length; i++){
      var box = document.getElementById(LISTS[i]);
      if(!box) continue;

      var links = [].slice.call(box.querySelectorAll('a[href*="/products/"]'));
      for(var j = 0; j < links.length; j++){
        var h = handleOf(links[j]);
        if(!h || !map[h]) continue;
        var card = cardIn(box, links[j]);
        if(card && card.parentNode){ card.parentNode.removeChild(card); removed++; }
      }

      /* A heading with nothing under it is worse than no heading. */
      var tier = box.closest ? box.closest('[id^="bt-tier"]') : null;
      if(tier) tier.style.display = box.children.length ? '' : 'none';
    }

    return removed;
  }

  var scheduled = false;
  function run(){
    if(scheduled) return;
    scheduled = true;
    load().then(function(map){
      scheduled = false;
      strip(map);
    });
  }

  run();

  if('MutationObserver' in window){
    var mo = new MutationObserver(function(records){
      /* Ignore our own removals, or this loops. */
      for(var i = 0; i < records.length; i++){
        if(records[i].addedNodes && records[i].addedNodes.length){ run(); return; }
      }
    });
    for(var k = 0; k < LISTS.length; k++){
      var b = document.getElementById(LISTS[k]);
      if(b) mo.observe(b, { childList: true });
    }
  }else{
    setInterval(run, 1200);
  }
})();